import React from 'react';
import {
  Form, Icon, Input, Button, Loader, Dimmer, Message
} from 'semantic-ui-react';
import PropTypes from 'prop-types';

const EmailEntry = (props) => {
  return (
    <div className='email-entry-form'>
      <Dimmer inverted={true} active={props.loading}>
        <Loader active={props.loading} />
      </Dimmer>
      <Form error>
        <Form.Group>
          <Form.Field>
            <Input
              spellCheck="false"
              placeholder='your email'
              value={props.email}
              onChange={(e, data) => {
                props.onEmailChange(data.value)
              }} />
          </Form.Field>
          <Button
            primary
            onClick={() => {
              props.handleSubmit(props.email)
            }}>
            Sign Up
            <Icon name='right arrow' />
          </Button>
        </Form.Group>
        { props.error && props.error.length > 0
          && <Message
              error
              content={props.error}
            />
        }
      </Form>
    </div>
  )
}

EmailEntry.propTypes = {
  handleSubmit: PropTypes.func,
  onEmailChange: PropTypes.func.isRequired,
  email: PropTypes.string.isRequired,
  error: PropTypes.string,
  loading: PropTypes.bool
}

EmailEntry.defaultProps = {
  handleSubmit: () => {}
}

export default EmailEntry;



// WEBPACK FOOTER //
// ./src/components/EmailEntry.js